"use strict";

import { constantStrings } from '../constants/constantStrings';
import * as commonConstants from '../constants/constantStrings';
import { LookupHelpers } from '../helpers/lookupHelpers';
import { DateHelpers } from '../helpers/dateHelpers';

export class FilmsComparedDialogModel {
  constructor(data) {
    this.modalService = null;
    this.scope = null;
    this.modalInstance = null;
    this.Patient = null;
    this.$ionicLoading = null;
    this.documentsSvc = null;
    this.techpadInitialConfigProvider = null;
    this.$rootScope = null;
    this.techpadConfig = null;
    this.dateFormattingHelper = null;
    this.documentPrintHelper = null;
    
    this.ssn = data && data.ssn ? data.ssn : '';
    this.sDate = data && data.sDate ? data.sDate : null;
    this.studyDate = data && data.studyDate ? data.studyDate : null;
    
    this.locations = data && data.locations ? data.locations.map(loc => ({
      Key: loc.Key || loc.Value,
      Value: loc.Value || loc.Name
    })) : [];
    this.cancelled = true;
    
    const savedData = data && data.savedData ? data.savedData : null;
    
    if (savedData) {
      this.noPriorFilmsCompared = savedData.noPriorFilmsCompared === true;
      this.noPriorFilmsAvailable = savedData.noPriorFilmsAvailable === true;
      this.reviewed = savedData.reviewed === true;
      this.comparedDatesNotSpecified = savedData.comparedDatesNotSpecified === true;
      this.comparedToStudiesDatingBack = savedData.comparedToStudiesDatingBack === true;
      this.toBeObtainedFrom = savedData.toBeObtainedFrom === true;
      this.baselineXRT = savedData.baselineXRT === true;
      this.baselineStudy = savedData.baselineStudy === true;
      this.noChange = savedData.noChange === true;
      const datingBackToValue = savedData.datingBackTo || '';
      if (datingBackToValue && datingBackToValue.indexOf('-') !== -1) {
        this.datingBackTo = DateHelpers.formatDateForDisplay(datingBackToValue, this.dateFormattingHelper);
      } else {
        this.datingBackTo = datingBackToValue;
      }
      this.obtainedFrom = savedData.obtainedFrom || '';
      this.obtainedFromLocationKey = savedData.obtainedFromLocationKey || '';
      this.originalObtainedFrom = savedData.obtainedFrom || '';
      this.originalObtainedFromLocationKey = savedData.obtainedFromLocationKey || '';
      this.obtainedFromLocationKeyAutoPopulated = false;
      
      if (!this.obtainedFromLocationKey && this.obtainedFrom && this.locations && this.locations.length > 0) {
        let matchingLocation = this.locations.find(loc => {
          const locationValue = loc.Value || loc.Name || '';
          return locationValue === this.obtainedFrom;
        });
        
        if (!matchingLocation) {
          matchingLocation = this.locations.find(loc => {
            const locationValue = loc.Value || loc.Name || '';
            return locationValue.indexOf(this.obtainedFrom) !== -1 || this.obtainedFrom.indexOf(locationValue) !== -1;
          });
        }
        
        if (matchingLocation) {
          this.obtainedFromLocationKey = matchingLocation.Key || matchingLocation.Value || '';
          this.obtainedFromLocationKeyAutoPopulated = true;
        }
      }
      
      this.includeCadStatement = savedData.includeCadStatement === true;
    } else {
      this.noPriorFilmsCompared = false;
      this.noPriorFilmsAvailable = false;
      this.reviewed = false;
      this.comparedDatesNotSpecified = false;
      this.comparedToStudiesDatingBack = false;
      this.toBeObtainedFrom = false;
      this.baselineXRT = false;
      this.baselineStudy = false;
      this.noChange = false;
      this.datingBackTo = '';
      this.obtainedFrom = '';
      this.obtainedFromLocationKey = '';
      this.originalObtainedFrom = '';
      this.originalObtainedFromLocationKey = '';
      this.obtainedFromLocationKeyAutoPopulated = false;
      this.includeCadStatement = false;
    }
    
    this.selectAllFilms = false;
    this.noChangeDisabled = false;
    this.loading = false;
    
    this.priorFilms = (data && data.priorFilms !== undefined && data.priorFilms !== null) ? data.priorFilms : [];
    this.savedSelectedFilms = savedData && savedData.selectedFilms ? savedData.selectedFilms : [];
    
    const hasSelectedFilms = this.savedSelectedFilms && this.savedSelectedFilms.length > 0;
    const hasOtherSelections = savedData && (
      savedData.noPriorFilmsCompared === true ||
      savedData.noPriorFilmsAvailable === true ||
      savedData.reviewed === true ||
      savedData.comparedDatesNotSpecified === true ||
      savedData.comparedToStudiesDatingBack === true ||
      savedData.toBeObtainedFrom === true ||
      savedData.baselineXRT === true ||
      savedData.baselineStudy === true ||
      savedData.noChange === true ||
      savedData.includeCadStatement === true ||
      (savedData.datingBackTo && savedData.datingBackTo !== '') ||
      (savedData.obtainedFrom && savedData.obtainedFrom !== '')
    );
    
    this.hasSavedData = savedData !== null && (hasSelectedFilms || hasOtherSelections);
    
    this.showNoPriorFilmsCompared = true;
    this.showNoPriorFilmsAvailable = true;
    this.showReviewed = true;
    this.showComparedDatesNotSpecified = true;
    this.showComparedToStudiesDatingBackTo = true;
    this.showToBeObtainedFrom = true;
    this.showBaselineStudy = true;
    this.showBaselineXRT = true;
    this.showIncludeCadStatement = true;
    this.showNoChange = true;
  }

  init(modal, scope, modalService, ionicDatePicker) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    
    let injector = null;
    
    if (scope && scope.$root && scope.$root.$injector) {
      injector = scope.$root.$injector;
    } else if (scope && scope.$injector) {
      injector = scope.$injector;
    } else if (typeof angular !== 'undefined' && angular.element) {
      try {
        injector = angular.element(document.body).injector();
      } catch (e) { }
    }
    
    if (!injector && this.modalService) {
      this.modalService.showAlert('Unable to initialize Films Compared dialog. Please refresh the page and try again.');
    }
    
    if (injector) {
      try {
        this.Patient = injector.get('Patient');
        this.$ionicLoading = injector.get('$ionicLoading');
        this.documentsSvc = injector.get('documentsSvc');
        this.techpadInitialConfigProvider = injector.get('techpadInitialConfigProvider');
        this.$rootScope = injector.get('$rootScope');
        this.techpadConfig = injector.get('techpadConfig');
        this.dateFormattingHelper = injector.get('dateFormattingHelper');
        this.documentPrintHelper = injector.get('documentPrintHelper');
      } catch (e) {
        if (this.modalService) {
          this.modalService.showAlert('Error initializing Films Compared dialog. Required services are not available.');
        }
      }
    }
    
    if (!this.priorFilms || this.priorFilms.length === 0) {
      this.priorFilms = [];
    }
    
    if (this.ssn && this.sDate && this.Patient) {
      this.loadFilmsComparedConfig();
    } else {
      this.noPriorFilmsAvailable = true;
      this.safeApply();
    }
  }

  /**
   * Safely applies scope changes
   */
  safeApply() {
    if (this.scope && this.scope.$root) {
      if (this.scope.$root.$$phase !== '$apply' && this.scope.$root.$$phase !== '$digest') {
        this.scope.$applyAsync();
      }
    }
  }

  /**
   * Loads films compared configuration from API and applies default selections
   */
  async loadFilmsComparedConfig() {
    if (!this.Patient || !this.ssn || !this.sDate) {
      return;
    }

    let loading = await this.$ionicLoading.show({
      template: constantStrings.PleaseWait
    });

    try {
      this.loading = true;
      this.safeApply();

      const sDateParam = DateHelpers.formatDateForApi(this.sDate);
      const studyDateParam = this.studyDate ? DateHelpers.formatDateForApi(this.studyDate) : null;

      const response = await this.Patient.getFilmsComparedConfig(
        this.ssn,
        sDateParam,
        studyDateParam
      );

      const config = response.data;
      const filmsToCompare = config && config.FilmsToCompare !== undefined ? config.FilmsToCompare : null;
      
      const optionsVisibility = config && config.OptionsVisibility ? config.OptionsVisibility : null;
      if (optionsVisibility) {
        this.showNoPriorFilmsCompared = optionsVisibility.ShowNoPriorFilmsCompared === true;
        this.showNoPriorFilmsAvailable = optionsVisibility.ShowNoPriorFilmsAvailable === true;
        this.showReviewed = optionsVisibility.ShowReviewed === true;
        this.showComparedDatesNotSpecified = optionsVisibility.ShowComparedDatesNotSpecified === true;
        this.showComparedToStudiesDatingBackTo = optionsVisibility.ShowComparedToStudiesDatingBackTo === true;
        this.showToBeObtainedFrom = optionsVisibility.ShowToBeObtainedFrom === true;
        this.showBaselineStudy = optionsVisibility.ShowBaselineStudy === true;
        this.showBaselineXRT = optionsVisibility.ShowBaselineXRT === true;
        this.showIncludeCadStatement = optionsVisibility.ShowIncludeCadStatement === true;
        this.showNoChange = optionsVisibility.ShowNoChange === true;
      }
      
      const defaultSelection = config && config.DefaultSelection ? config.DefaultSelection : null;
      
      if (filmsToCompare && Array.isArray(filmsToCompare) && filmsToCompare.length > 0) {
        const applyAutoSelection = !this.hasSavedData && (!defaultSelection || !this.hasDefaultSelectionSet(defaultSelection));
        this.priorFilms = this.transformApiFilmsToPriorFilms(filmsToCompare, applyAutoSelection);
        
        if (this.hasSavedData) {
          if (this.savedSelectedFilms && this.savedSelectedFilms.length > 0) {
            this.restoreSavedSelections();
          }
        } else {
          this.applyDefaultSelections(config, defaultSelection);
        }
      } else {
        this.priorFilms = [];
        if (!this.hasSavedData) {
          if (defaultSelection && this.hasDefaultSelectionSet(defaultSelection)) {
            this.applyDefaultSelectionOptions(defaultSelection, config);
          } else {
            const compNum = config && config.CompNum !== undefined ? config.CompNum : 0;
            const compMonths = config && config.CompMonths !== undefined ? config.CompMonths : 0;
            const compRule = config && config.CompRule !== undefined ? config.CompRule : '';
            
            if (compNum === 0 && compMonths === 0 && !compRule) {
              this.noPriorFilmsAvailable = true;
            }
          }
        }
      }

      this.updateNoChangeDisabledState();
      this.updateSelectAllState();
      this.safeApply();

      loading.hide();
    } catch (error) {
      loading.hide();
      if (this.modalService) {
        const errorMessage = error.data || error.message || 'Error loading films compared configuration. Please try again.';
        this.modalService.showErrorMessage(errorMessage, error.status);
      }
      this.priorFilms = this.priorFilms || [];
      this.safeApply();
    } finally {
      this.loading = false;
      if (this.$ionicLoading) {
        this.$ionicLoading.hide();
      }
      this.safeApply();
    }
  }

  /**
   * Transforms API FilmsComparedItemDto[] to priorFilms format
   * Films are sorted by StudyDate descending (most recent first)
   * Films with ShouldCompare=true are initially selected only if applyAutoSelection is true
   * @param {Array} apiFilms - Array of film objects from API
   * @param {boolean} applyAutoSelection - Whether to auto-select films based on ShouldCompare flag (default: true)
   */
  transformApiFilmsToPriorFilms(apiFilms, applyAutoSelection) {
    if (!apiFilms || !Array.isArray(apiFilms)) {
      return [];
    }

    if (applyAutoSelection === undefined) {
      applyAutoSelection = true;
    }

    let idCounter = 1;
    const transformedFilms = apiFilms.map(film => {
      const studyDate = film.StudyDate ? DateHelpers.formatDateForDisplay(film.StudyDate, this.dateFormattingHelper) : '';
      const shouldCompare = film.shouldCompare === true || film.ShouldCompare === true;
      
      let proceduresStr = '';
      if (film.Procedures && film.Procedures.length > 0) {
        proceduresStr = film.Procedures.map(p => `${p.Name} - ${LookupHelpers.getFullSideByCode(p.Side)}`).join(', ');
      }
      const locationFullName = film.LocationName ? LookupHelpers.getLocationName(film.LocationName, this.locations) : ''; // rename locationName to locationKey

      let locationValue = locationFullName;
      if (locationFullName) {
        if (locationValue.indexOf(',') !== -1) {
          locationValue = locationValue.split(',').slice(1).join(' ').trim();
        }
        locationValue = locationValue.trim();
      }

      let displayText = '';
      if (proceduresStr) {
        displayText = `${studyDate} ${proceduresStr} at ${locationValue}`;
      } else {
        displayText = `${studyDate} at ${locationValue}`;
        if (film.Description && film.LocationName) {
          const locationKeyStr = film.LocationName.toString();
          const locationKeyIndex = film.Description.indexOf(' at ' + locationKeyStr);
          if (locationKeyIndex !== -1) {
            let afterLocation = film.Description.substring(locationKeyIndex + ' at '.length + locationKeyStr.length).trim();
            if (afterLocation) {
              afterLocation = afterLocation.replace(/^[\s-]+/, '');
              if (afterLocation) {
                displayText = `${displayText} - ${afterLocation}`;
              }
            }
          } else if (film.Modality) {
            displayText = `${displayText} - ${film.Modality}`;
          }
        } else if (film.Modality) {
          displayText = `${displayText} - ${film.Modality}`;
        }
      }
      displayText = displayText || 'Unknown';

      return {
        Id: idCounter++,
        StudyDate: studyDate ? DateHelpers.formatDateForApi(studyDate) : '',
        DescriptionToDisplay: displayText,
        LocationToDisplay: locationFullName,
        DisplayText: displayText,
        Selected: applyAutoSelection ? shouldCompare : false,
        isSwiped: false,
        _apiData: {
          ssn: film.ssn || film.Ssn,
          sDate: film.sDate || film.SDate,
          studyDate: film.studyDate || film.StudyDate,
          isPrevMammo: film.isPrevMammo || film.IsPrevMammo || false,
          prevMammoId: film.prevMammoId || film.PrevMammoId,
          docId: film.docId || film.DocId,
          shouldCompare: shouldCompare
        }
      };
    });

    transformedFilms.sort((a, b) => {
      const dateA = a._apiData && a._apiData.studyDate ? new Date(a._apiData.studyDate) : new Date(0);
      const dateB = b._apiData && b._apiData.studyDate ? new Date(b._apiData.studyDate) : new Date(0);
      return dateB.getTime() - dateA.getTime();
    });

    return transformedFilms;
  }

  /**
   * Checks if DefaultSelection has any option set to true
   */
  hasDefaultSelectionSet(defaultSelection) {
    if (!defaultSelection) {
      return false;
    }
    return defaultSelection.BaselineStudy === true ||
           defaultSelection.NoPriorAvailable === true ||
           defaultSelection.NoPriorCompared === true ||
           defaultSelection.NoStatement === true ||
           defaultSelection.BaselineXRT === true ||
           defaultSelection.ComparedDatesNotSpecified === true ||
           defaultSelection.ComparedToStudiesDatingBackTo === true ||
           defaultSelection.ToBeObtainedFrom === true ||
           defaultSelection.Reviewed === true;
  }

  /**
   * Applies default selection options from DefaultSelection object
   */
  applyDefaultSelectionOptions(defaultSelection, config) {
    if (!defaultSelection) {
      return;
    }

    let selectedOption = null;

    if (defaultSelection.BaselineStudy === true) {
      this.baselineStudy = true;
      selectedOption = 'baselineStudy';
      
      if (defaultSelection.NoPriorAvailable === true) {
        this.noPriorFilmsAvailable = true;
      }
      
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.NoPriorAvailable === true) {
      this.noPriorFilmsAvailable = true;
      selectedOption = 'noPriorFilmsAvailable';
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.NoPriorCompared === true) {
      this.noPriorFilmsCompared = true;
      selectedOption = 'noPriorFilmsCompared';
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.BaselineXRT === true) {
      this.baselineXRT = true;
      selectedOption = 'baselineXRT';
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.ComparedDatesNotSpecified === true) {
      this.comparedDatesNotSpecified = true;
      selectedOption = 'comparedDatesNotSpecified';
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.ComparedToStudiesDatingBackTo === true) {
      this.comparedToStudiesDatingBack = true;
      selectedOption = 'comparedToStudiesDatingBack';
      const compDate = config && config.CompDate !== undefined ? config.CompDate : '';
      if (compDate) {
        if (compDate.indexOf('-') !== -1) {
          this.datingBackTo = DateHelpers.formatDateForDisplay(compDate, this.dateFormattingHelper);
        } else if (compDate.match(/^\d{4}$/)) {
          this.datingBackTo = compDate;
        } else {
          this.datingBackTo = compDate;
        }
      }
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    } else if (defaultSelection.ToBeObtainedFrom === true) {
      this.toBeObtainedFrom = true;
      selectedOption = 'toBeObtainedFrom';
      if (this.priorFilms && this.priorFilms.length > 0) {
        this.priorFilms.forEach(film => {
          film.Selected = false;
        });
        this.selectAllFilms = false;
      }
    }

    if (selectedOption) {
      this.clearConflictingOptions(selectedOption);
    }

    if (defaultSelection.Reviewed === true) {
      this.reviewed = true;
    }
  }

  /**
   * Applies default selections based on API configuration
   */
  applyDefaultSelections(config, defaultSelection) {
    if (!config) {
      return;
    }

    if (defaultSelection && this.hasDefaultSelectionSet(defaultSelection)) {
      this.applyDefaultSelectionOptions(defaultSelection, config);
      return;
    }

    if (!this.priorFilms || this.priorFilms.length === 0) {
      return;
    }

    const compRule = config.CompRule || '';
    const compDate = config.CompDate !== undefined ? config.CompDate : '';
    const compNum = config.CompNum !== undefined ? config.CompNum : 0;
    const compMonths = config.CompMonths !== undefined ? config.CompMonths : 0;

    if (compRule && compRule.toUpperCase() === 'D' && compDate) {
      this.comparedToStudiesDatingBack = true;
      if (compDate && compDate.indexOf('-') !== -1) {
        this.datingBackTo = DateHelpers.formatDateForDisplay(compDate, this.dateFormattingHelper);
      } else if (compDate && compDate.match(/^\d{4}$/)) {
        this.datingBackTo = compDate;
      } else {
        this.datingBackTo = compDate;
      }
      return;
    }

    const hasFilmsToCompare = this.priorFilms.some(film => 
      film._apiData && film._apiData.shouldCompare === true
    );

    if (!hasFilmsToCompare) {
      if (compNum === 0 && compMonths === 0 && !compRule) {
        this.noPriorFilmsAvailable = true;
      }
    }
  }

  /**
   * Restores saved selections from previously saved data
   */
  restoreSavedSelections() {
    if (!this.savedSelectedFilms || !Array.isArray(this.savedSelectedFilms) || !this.priorFilms || this.priorFilms.length === 0) {
      return;
    }

    this.priorFilms.forEach(film => {
      const savedFilm = this.savedSelectedFilms.find(saved => {
        if (saved.StudyDate && film.StudyDate) {
          const savedDate = DateHelpers.formatDateForApi(saved.StudyDate);
          const filmDate = DateHelpers.formatDateForApi(film.StudyDate);
          if (savedDate === filmDate) {
            return true;
          }
        }

        if (saved._apiData && film._apiData) {
          const savedDocId = saved._apiData.docId || saved._apiData.DocId;
          const filmDocId = film._apiData.docId || film._apiData.DocId;
          if (savedDocId && filmDocId && savedDocId === filmDocId) {
            return true;
          }
          const savedSDate = saved._apiData.sDate || saved._apiData.SDate;
          const filmSDate = film._apiData.sDate || film._apiData.SDate;
          const savedStudyDate = saved._apiData.studyDate || saved._apiData.StudyDate;
          const filmStudyDate = film._apiData.studyDate || film._apiData.StudyDate;
          if (savedSDate === filmSDate && savedStudyDate === filmStudyDate) {
            return true;
          }
        }
        return false;
      });
      
      if (savedFilm) {
        film.Selected = true;
      }
    });

    this.updateSelectAllState();
  }

  /**
   * Updates selectAllFilms state based on current selections
   */
  updateSelectAllState() {
    if (!this.priorFilms || this.priorFilms.length === 0) {
      this.selectAllFilms = false;
      return;
    }
    this.selectAllFilms = this.priorFilms.every(f => f.Selected === true);
  }

  hasAnyFilmSelected() {
    if (!this.priorFilms || !Array.isArray(this.priorFilms)) {
      return false;
    }
    return this.priorFilms.some(f => f && f.Selected === true);
  }

  onNoPriorFilmsComparedChange() {
    if (this.noPriorFilmsCompared) {
      this.clearConflictingOptions('noPriorFilmsCompared');
      this.noChange = false;
    }
    this.updateNoChangeDisabledState();
  }

  onNoPriorFilmsAvailableChange() {
    if (this.noPriorFilmsAvailable) {
      this.clearConflictingOptions('noPriorFilmsAvailable');
      this.noChange = false;
    }
    this.updateNoChangeDisabledState();
  }

  updateNoChangeDisabledState() {
    this.noChangeDisabled = this.noPriorFilmsCompared || this.noPriorFilmsAvailable || this.baselineXRT;
    this.safeApply();
  }

  onReviewedChange() {
    if (this.reviewed) {
      this.clearConflictingOptions('reviewed');
    }
    this.updateNoChangeDisabledState();
  }

  onComparedDatesNotSpecifiedChange() {
    if (this.comparedDatesNotSpecified) {
      this.clearConflictingOptions('comparedDatesNotSpecified');
    }
    this.updateNoChangeDisabledState();
  }

  onComparedToStudiesDatingBackChange() {
    if (!this.comparedToStudiesDatingBack) {
      this.datingBackTo = '';
    }
    if (this.comparedToStudiesDatingBack) {
      this.clearConflictingOptions('comparedToStudiesDatingBack');
    }
    this.updateNoChangeDisabledState();
  }

  onToBeObtainedFromChange() {
    if (!this.toBeObtainedFrom) {
      this.obtainedFrom = '';
      this.obtainedFromLocationKey = '';
    }
    if (this.toBeObtainedFrom) {
      this.clearConflictingOptions('toBeObtainedFrom');
    }
    this.updateNoChangeDisabledState();
  }

  onBaselineXRTChange() {
    if (this.baselineXRT) {
      this.clearConflictingOptions('baselineXRT');
      this.noChange = false;
    }
    this.updateNoChangeDisabledState();
  }

  onBaselineStudyChange() {
    if (this.baselineStudy) {
      this.clearConflictingOptions('baselineStudy');
    }
    this.updateNoChangeDisabledState();
  }

  clearConflictingOptions(selectedOption) {
    if (selectedOption !== 'noPriorFilmsCompared') {
      this.noPriorFilmsCompared = false;
    }
    if (selectedOption !== 'noPriorFilmsAvailable') {
      this.noPriorFilmsAvailable = false;
    }
    if (selectedOption !== 'reviewed') {
      this.reviewed = false;
    }
    if (selectedOption !== 'comparedDatesNotSpecified') {
      this.comparedDatesNotSpecified = false;
    }
    if (selectedOption !== 'comparedToStudiesDatingBack') {
      this.comparedToStudiesDatingBack = false;
      this.datingBackTo = '';
    }
    if (selectedOption !== 'toBeObtainedFrom') {
      this.toBeObtainedFrom = false;
      this.obtainedFrom = '';
      this.obtainedFromLocationKey = '';
    }
    if (selectedOption !== 'baselineXRT') {
      this.baselineXRT = false;
    }
    if (selectedOption !== 'baselineStudy') {
      this.baselineStudy = false;
    }
    if (selectedOption !== 'noChange' && selectedOption !== 'includeCadStatement' && 
        selectedOption !== 'reviewed' && selectedOption !== 'toBeObtainedFrom' && this.hasAnyFilmSelected()) {
      this.priorFilms.forEach(film => {
        film.Selected = false;
      });
      this.selectAllFilms = false;
    }
  }

  onFilmSelectionChange(film) {
    const allSelected = this.priorFilms.every(f => f.Selected);
    this.selectAllFilms = allSelected;
    
    if (film.Selected && this.hasAnyFilmSelected()) {
      this.clearConflictingOptionsForFilms();
    }
  }

  toggleFilmSelection(film) {
    if (!film) {
      return;
    }
    film.Selected = !film.Selected;
    this.onFilmSelectionChange(film);
  }

  onSelectAllChange() {
    this.priorFilms.forEach(film => {
      film.Selected = this.selectAllFilms;
    });
    
    if (this.selectAllFilms && this.hasAnyFilmSelected()) {
      this.clearConflictingOptionsForFilms();
    }
  }

  clearConflictingOptionsForFilms() {
    this.noPriorFilmsCompared = false;
    this.noPriorFilmsAvailable = false;
    this.comparedDatesNotSpecified = false;
    this.comparedToStudiesDatingBack = false;
    this.toBeObtainedFrom = false;
    this.baselineXRT = false;
    this.baselineStudy = false;
    this.datingBackTo = '';
    this.obtainedFrom = '';
    this.obtainedFromLocationKey = '';
    this.updateNoChangeDisabledState();
  }

  onLocationSelected(selectedKey) {
    if (selectedKey && this.locations && this.locations.length > 0) {
      const location = this.locations.find(loc => (loc.Key || loc.Value) === selectedKey);
      if (location) {
        this.obtainedFromLocationKey = selectedKey;
        this.obtainedFrom = location.Value || location.Name || selectedKey;
      } else {
        this.obtainedFromLocationKey = selectedKey;
        this.obtainedFrom = LookupHelpers.getLocationName(selectedKey, this.locations);
      }
      this.obtainedFromLocationKeyAutoPopulated = false;
    } else {
      this.obtainedFromLocationKey = '';
      this.obtainedFrom = '';
      this.obtainedFromLocationKeyAutoPopulated = false;
    }
  }

  getDisplayText() {
    if (this.toBeObtainedFrom) {
      return 'To be obtained';
    }
    
    const selectedFilms = this.priorFilms.filter(f => f.Selected);
    
    if (selectedFilms.length > 0) {
      const dates = selectedFilms.map(f => {
        return f.StudyDate ? DateHelpers.formatDateForDisplay(f.StudyDate, this.dateFormattingHelper) : '';
      }).filter(d => d);
      
      if (dates.length > 0) {
        if (this.reviewed === true) {
          return 'Reviewed ' + dates.join(', ');
        }
        return 'Compared ' + dates.join(', ');
      }
      if (this.reviewed === true) {
        return 'Reviewed';
      }
      return 'Compared';
    }
    
    if (this.noPriorFilmsCompared) {
      return 'Not compared';
    }
    
    if (this.noPriorFilmsAvailable) {
      return 'Not available';
    }
    
    if (this.reviewed) {
      return 'Reviewed';
    }
    
    if (this.comparedDatesNotSpecified) {
      return 'Compared';
    }
    
    if (this.comparedToStudiesDatingBack && this.datingBackTo) {
      return 'Dating back to ' + this.datingBackTo;
    }
    
    if (this.baselineXRT) {
      return 'Baseline XRT';
    }
    
    if (this.baselineStudy) {
      return 'Baseline study';
    }
    
    return '';
  }

  async viewFilmDetails(film) {
    if (!film || !film._apiData) {
      if (this.modalService) {
        this.modalService.showAlert('Film details: ' + (film ? film.DisplayText : 'Unknown'));
      }
      return;
    }

    const apiData = film._apiData;
    const isPrevMammo = apiData.isPrevMammo === true || apiData.IsPrevMammo === true;

    if (!this.documentsSvc || !this.$ionicLoading || !this.modalService) {
      if (this.modalService) {
        this.modalService.showAlert('Unable to view report. Required services are not available.');
      }
      return;
    }

    try {
      this.$ionicLoading.show({
        template: commonConstants.DOCUMENT_LOADING_MESSAGE
      });

      const ssn = apiData.ssn || apiData.Ssn || this.ssn;
      const sDate = apiData.sDate || apiData.SDate || DateHelpers.formatDateForApi(this.sDate);
      const docId = apiData.docId || apiData.DocId;

      if (isPrevMammo && !docId) {
        this.$ionicLoading.hide();
        this.modalService.showAlert('Document ID not available for this previous mammogram.');
        return;
      }

      if (!isPrevMammo && (!ssn || !sDate)) {
        this.$ionicLoading.hide();
        this.modalService.showAlert('SSN and study date are required to view this report.');
        return;
      }

      let document = null;

      try {
        const response = await this.documentsSvc.getFilmsComparedDocument(
          ssn,
          sDate,
          isPrevMammo,
          docId
        );
        document = response.data;
      } catch (error) {
        this.$ionicLoading.hide();
        if (isPrevMammo) {
          this.modalService.showAlert('Document not found for this previous mammogram.');
        } else {
          this.modalService.showAlert(
            commonConstants.STUDY_REPORT_UNAVAILABLE,
            undefined,
            undefined,
            commonConstants.REPORT_UNAVAILABLE,
            commonConstants.advancedConfirmationCancelButtonText
          );
        }
        return;
      }

      if (!document || !document.Id) {
        this.$ionicLoading.hide();
        this.modalService.showAlert('Report not available for this film.');
        return;
      }

      const url = await this.documentsSvc.getDocumentUrl(document);
      
      // if (!this.documentPrintHelper) {
      //   this.$ionicLoading.hide();
      //   if (this.modalService) {
      //     this.modalService.showAlert('Document print helper service is not available.');
      //   }
      //   return;
      // }
      
      if (this.techpadInitialConfigProvider && this.techpadInitialConfigProvider.setFromElectron) {
        this.documentPrintHelper.openDocumentElectron(url);
      } else {
        this.documentPrintHelper.openDocumentBrowser(url, document, {
          patient: null
        });
      }
    } catch (error) {
      this.$ionicLoading.hide();
      if (this.modalService) {
        const errorMessage = error.data || error.message || 'Error loading report. Please try again.';
        this.modalService.showErrorMessage(errorMessage, error.status);
      }
    }
  }


  save() {
    this.cancelled = false;
    this.displayText = this.getDisplayText();
    this.updateSelectAllState();
    
    if (this.obtainedFromLocationKeyAutoPopulated && 
        this.obtainedFrom === this.originalObtainedFrom &&
        this.obtainedFromLocationKey !== this.originalObtainedFromLocationKey) {
      this.obtainedFromLocationKey = this.originalObtainedFromLocationKey;
    }

    if (this.priorFilms && this.priorFilms.length > 0) {
      const selectedFilms = this.priorFilms.filter(f => f.Selected).map(film => {
        return {
          StudyDate: film.StudyDate || '',
          Ssn: film._apiData ? (film._apiData.ssn || film._apiData.Ssn || this.ssn) : this.ssn,
          SDate: film._apiData ? (film._apiData.sDate || film._apiData.SDate || '') : '',
          IsPrevMammo: film._apiData ? (film._apiData.isPrevMammo || film._apiData.IsPrevMammo || false) : false,
          PrevMammoId: film._apiData ? (film._apiData.prevMammoId || film._apiData.PrevMammoId || '') : '',
          LocationName: film.LocationToDisplay || film.DisplayText || '',
          DocId: film._apiData ? (film._apiData.docId || film._apiData.DocId || '') : ''
        };
      });
      
      if (!this.selectedFilmsForSave) {
        this.selectedFilmsForSave = [];
      }
      this.selectedFilmsForSave = selectedFilms;
    }
    
    this.modalInstance.remove();
  }

  async closeWindow() {
    this.cancelled = true;
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/filmsComparedDialogModel.js